import { forwardRef } from "react";
import { Bar } from "react-chartjs-2";

import {
  Chart as ChartJS,
  BarElement,
  CategoryScale,
  LinearScale,
  Tooltip,
  Legend,
} from "chart.js";

ChartJS.register(BarElement, CategoryScale, LinearScale, Tooltip, Legend);

const whiteCanvasBackgroundPlugin = {
  id: "whiteCanvasBackground",
  beforeDraw(chart) {
    const { ctx, width, height } = chart;
    ctx.save();
    ctx.globalCompositeOperation = "destination-over";
    ctx.fillStyle = "#ffffff";
    ctx.fillRect(0, 0, width, height);
    ctx.restore();
  },
};

const MAX_CHART_HEIGHT = "240px";

const CAPTURE_SIZE = {
  width: "650px",
  height: MAX_CHART_HEIGHT,
  maxHeight: MAX_CHART_HEIGHT,
};

const RESPONSIVE_SIZE = {
  width: "100%",
  height: "100%",
  maxHeight: MAX_CHART_HEIGHT,
};

const FftBarGraph = forwardRef(function FftBarGraph(
  { data, isCapture = false },
  ref,
) {
  if (!data) return null;

  const chartSize = isCapture ? CAPTURE_SIZE : RESPONSIVE_SIZE;

  const chartData = {
    datasets: [
      {
        label: "Amplitude (dB)",
        data: data,
        backgroundColor: "#1868db",
        borderSkipped: false, // 막대 테두리 안 잘리게
        barThickness: 1, // 막대 두께 고정
      },
    ],
  };

  const options = {
    maintainAspectRatio: false, // 비율 고정 해제
    responsive: true,
    scales: {
      x: {
        type: "linear",
        offset: false, // 축 시작 간격 제거
        title: {
          display: true,
          text: "Frequency (kHz)",
        },
        min: 0,
        max: 48,
        ticks: {
          stepSize: 12,
          callback: (value) => value + " kHz",
        },
      },
      y: {
        title: {
          display: true,
          text: "Amplitude (dB)",
        },
        min: 0,
        max: 100,
        ticks: {
          stepSize: 10,
          callback: (value) => value + " dB",
        },
      },
    },
    plugins: {
      legend: {
        display: false,
      },
      tooltip: {
        callbacks: {
          label: (context) => `Amplitude: ${context.parsed.y.toFixed(1)} dB`,
        },
      },
    },
  };

  const chartFrameStyle = {
    ...chartSize,
    backgroundColor: "#ffffff",
    overflow: "hidden",
  };

  return (
    <div ref={ref || null} style={chartFrameStyle}>
      <div style={chartFrameStyle}>
        <Bar
          data={chartData}
          options={options}
          plugins={[whiteCanvasBackgroundPlugin]}
        />
      </div>
    </div>
  );
});

export default FftBarGraph;
